import { createStore } from 'vuex'

export default createStore({
  state: {
    address:'',
    days:'Monday-Friday',
    hours:'8:45 AM - 4:30 PM',
    API:'https://athletics.fanportal-mlb.com/booking/api',
    repId:'',
    repPurl:undefined,
    selectedBooking:'',
    selectedDate:'',
    availableBookings:[],
    selectedSchedule:'',
    client: {
      name:'',
      first:'',
      last:'',
      email:'',
      tmId:'',
    }
  },
  getters: {
  },
  mutations: {
    setClient(state, value) {
      state.client.first = value.first_name ?? '';
      state.client.last = value.last_name ?? '';
      state.client.email = value.email ?? '';
      state.client.tmId = value.tm_id ?? '';
    },
    setRepPurl(state, value) {
      state.repPurl = value;
    },
    setRepId(state, id) {
      state.repId = id;
    },
    setSelectedSchedule(state, date) {
      state.selectedSchedule = date;
    },
    setSelectedDate(state, date) {
      state.selectedDate = date;
    },
    setSelectedBooking(state, date) {
      state.selectedBooking = date;
    },
    setAvailableBookings(state, bookings) {
      state.availableBookings = bookings;
    },
  },
  actions: {
  },
  modules: {
  }
})
